import moment from "moment"

const _DAYS = {
  NOW: moment(),
  TODAY: moment().startOf("day").format(),
}

const _YEAR_MONTH_DAT_HOUR_MINUTE_SECOND = "YYYY-MM-DD HH:mm:ss"
export const DATE_FORMAT_DAY_MONTH_TIME = "ddd DD MMM, HH:mm" // Mon 01 Jan 12:00
export const DATE_FORMAT_DAY_MONTH_YEAR = "ddd DD MMM, YYYY" // Mon 01 Jan, 2023
export const DATE_FORMAT_DAY_MONTH = "ddd DD MMM" // Mon 01 Jan, 2023
export const DATE_FORMAT_DAY_MONTH_SHORT = "DD MMM" // 01 2023

export const timeFormatter = (createdAt: Date) => moment(createdAt).fromNow()

export const formatEvent = (event: { start?: Date | null; end?: Date | null }) => {
  if (!event.start || !event.end) {
    return ""
  }
  return `${moment(event.start).format(DATE_FORMAT_DAY_MONTH_TIME)} - ${moment(event.end).format(
    "HH:mm",
  )}`
}
